import { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorCode } from './Error';
import { mapError } from './mapError';
import ValidationResult from './ValidationResult';

export default class ErrorResponse extends ApiClientErrorResponse {
	handleProductGroupNotFound(): boolean {
		return this.handle('product-group-not-found');
	}

	handleProductGroupLocked(): boolean {
		return this.handle('product-group-locked');
	}

	handleCannotChangeSettingsForNonMemberProducts(): boolean {
		return this.handle(ErrorCode.cannotChangeSettingsForNonMemberProducts);
	}

	handleRequiredProductSettingsMissing(): boolean {
		return this.handle(ErrorCode.requiredProductSettingsMissing);
	}

	handleRequiresMinOneEuropeanProduct(): boolean {
		return this.handle(ErrorCode.requiresMinOneEuropeanProduct);
	}

	handleRequiresMaxOneEuropeanProduct(): boolean {
		return this.handle(ErrorCode.requiresMaxOneEuropeanProduct);
	}

	handleRequiresReferenceSettingsErrorCode(): boolean {
		return this.handle(ErrorCode.requiresReferenceSettings);
	}

	handleIllegalPriceTypeSelected(): boolean {
		return this.handle(ErrorCode.illegalPriceTypeSelected);
	}

	handleExportB1RequiresReferenceCountries(): boolean {
		return this.handle(ErrorCode.exportB1RequiresReferenceCountries);
	}

	toValidationResult(): ValidationResult {
		const errors = this.errors.map(mapError);

		return new ValidationResult(
			errors.find((error) => error.code === ErrorCode.requiresReferenceSettings) !== undefined,
			errors.filter((error) => error.productId !== null),
			errors.filter((error) => error.duplicateCountries.length > 0)
		);
	}
}
